import React from 'react';
import PropTypes from 'prop-types';
import _toLower from 'lodash/toLower';
// Custom
import OneparkLogo from 'assets/images/onepark/LOGO_OnePark_Bleu.png';
import OneparkLogoBlue from 'assets/images/onepark/LOGO_OnePark_Bleu.svg';
import OneparkLogoWhite from 'assets/images/onepark/LOGO_OnePark_Blanc.svg';
// Flow
import FlowLogo from 'assets/images/flow/flow.svg';

const flagContext = require.context('assets/images/flags/4x3', false, /\.svg$/);

export const FlagImg = ({ countryCode, width }) => {
  try {
    const flagModule = flagContext(`./${_toLower(countryCode)}.svg`);
    const flagPath = flagModule.default;

    return <img src={flagPath} alt={`Flag of ${countryCode}`} width={width} />;
  } catch (error) {
    return null;
  }
};

FlagImg.propTypes = {
  countryCode: PropTypes.string.isRequired,
  width: PropTypes.number,
};

FlagImg.defaultProps = {
  width: 35,
};

// Onepark
export const OneparkLogoImg = (width, height) => <img src={OneparkLogo} width={width} height={height} alt="" />;
export const OneparkLogoBlueImg = (width, height) => <img src={OneparkLogoBlue} width={width} height={height} alt="" />;
export const OneparkLogoWhiteImg = (width, height) => <img src={OneparkLogoWhite} width={width} height={height} alt="" />;

// Flow
export const FlowLogoImg = (width, height) => <img src={FlowLogo} width={width} height={height} alt="" />;



// WEBPACK FOOTER //
// ./components/img/AssetImg.js